module.exports = __webpack_public_path__ + "img/ibank.f090fec6.svg";